const color = [
	'#000000',
	'#A92B21',
	'#699C1E',
	'#24B829',
	'#378A6E',
	'#5A5A5A',
	'#5A5A5A',
	'#378A6E',
	'#24B829',
	'#699C1E',
	'#A92B21'
];

const background = {
	color: color.map(c => `${c}4D`) // Add transparency to the colors from above
};

const label = {
	color: null, // the label will use the section color if this is not defined.
	format: {
		default: '0,.2f',
		percent: '0,.2%'
	},
	font: {
		family: 'Arial, Helvetica, sans-serif',
		size: 12,
		weight: 'normal'
	}
};

const thresholds = [
	0,
	0.236,
	0.382,
	0.5,
	0.618,
	1,
	1.618,
	2.618,
	3.618,
	4.236
];

export default {
	fibArc: {
		background: { color: background.color.slice(1, 6) },
		color: color.slice(1, 6),
		label,
		thresholds: thresholds.slice(1, 6),
		width: 1
	},
	fibCircle: {
		background: { color: background.color.slice(1, 6) },
		color: color.slice(1, 6),
		label,
		thresholds: thresholds.slice(1, 6),
		width: 1
	},
	fibFan: {
		background: { color: background.color.slice(0, 6) },
		color: color.slice(0, 6),
		label,
		thresholds: thresholds.slice(0, 6),
		width: 1
	},
	fibonacci: {
		background,
		color,
		label,
		thresholds,
		width: 1
	}
};
